<template>
  <div class="kr-layout-content">
    <!--个人基本资料-->
    <div class="publish graphicManage">
      <div class="publish-top">
        <ul class="per-list">
          <li class="active">动态管理</li>
        </ul>
      </div>
	  <!-- 搜索 -->
	  <div class="classify">
	    <div class="search-cont">
	      <input
	        type="text"
	        placeholder="请输入关键词进行搜索"
	        v-model="keyWords"
	        v-on:keyup.enter="getList(keyWords)"
	      />
	      <label @click="getList(keyWords)">搜索</label>
	    </div>
	  </div>
      <!-- 列表 -->
      <ul class="edit-article">
        <li class="list" v-for="item in manageList" :key="item.id">
          <div class="content">
            <div class="top-title">
              <p class="title oneline">{{item.title}}</p>
              <div v-if="item.status==3" class="sta-btn draft">已发布</div>
              <div v-if="item.status==2" class="sta-btn no-pass">未通过</div>
              <div v-if="item.status==1" class="sta-btn check">未通过</div>
            </div>
            <ul class="dy-img">
              <!-- <li v-for="(itemImg,index) in item.imgUrl" :key="index">
                <img :src="item.imgUrl" alt />
              </li>-->
              <li>
                <img :src="item.imgUrl[0]" alt />
              </li>
            </ul>
            <div class="time">{{item.createTime}}</div>
          </div>
          <div class="operation">
            <span class="del" @click="dele(item.id)">删除</span>
          </div>
        </li>
      </ul>
      <p v-if="listNone" class="none-more">暂无信息</p>
      <!-- 分页 -->
      <div v-if="!listNone" class="paging">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            layout="prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import { spawn } from "child_process";
export default {
  // name: "App",
  data() {
    return {
      num: 0,
      manageList: [],
	  keyWords: "",
      pageNo: 1,
      totalNum: 0,
      currentPage3: 1,
      listNone: false,
      ruleContent: ""
    };
  },
  mounted() {
    this.getList(this.keyWords);
  },
  methods: {
    handleSizeChange(val) {
      this.pageNo = val;
      this.getList();
      document.documentElement.scrollTop = 0;
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
      document.documentElement.scrollTop = 0;
    },
    getList() {
      //动态管理列表
      this.$http
        .get("/api/media/014-myDongTaiList", {
          params: {
            pageNo: this.pageNo,
			title: this.keyWords,
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {   
          //  console.log(res, "动态列表");  
          if (res.data.code == 0) {
            $.each(res.data.rows, function(k,v) {
                res.data.rows[k].imgUrl = v.imgUrl.split(',');
            });
            this.manageList = res.data.rows;
            if (res.data.rows.length == 0) {
              this.listNone = true;
            } else {
              this.totalNum = res.data.totalCount;
              this.num = res.data.rows[0].todayCount;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    dele(id) {
      //媒体认证
      this.$http
        .get("/api/zhaoPin/005-delDontTaiById", {
          params: {
            id: id,
            token: this.$store.state.userInfo.token
          }
        })
        .then(res => {
          // console.log(res, "删除");
          if (res.data.code == 0) {
            this.getList();
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.graphicManage .edit-article {
  margin-top: 30px;
}
.graphicManage .edit-article .list {
  height: auto;
  padding: 20px 10px;
  overflow: hidden;
}
.graphicManage .edit-article .list .art-img {
  width: 300px;
  height: 165px;
}
.graphicManage .edit-article .list .cont {
  width: calc(100% - 400px);
  height: 165px;
}
.graphicManage .edit-article .list .operation {
  width: 100px;
  line-height: 160px;
}
.graphicManage .edit-article .list .content {
  width: calc(100% - 100px);
  height: 100%;
  float: left;
}
.graphicManage .edit-article .list .content .top-title {
  text-align: left;
}
.graphicManage .edit-article .list .content .top-title p {
  text-align: left;
  font-size: 14px;
  max-width: calc(100% - 80px);
  float: left;
}
.graphicManage .edit-article .list .content .dy-img {
  width: 100%;
  height: 100%;
  padding: 15px 0px;
  overflow: hidden;
}
.graphicManage .edit-article .list .content .dy-img li {
  width: 150px;
  height: 120px;
  float: left;
  margin-right: 10px;
}
.graphicManage .edit-article .list .content .time {
  text-align: left;
  color: #999;
  font-size: 12px;
}

</style>
